module.exports = __webpack_public_path__ + "static/media/slider4.9d46b901.jpg";